export default {
  reviewCompleteHeader: 'Tarkista ja viimeistele',
  participants: 'Osallistujat',
  enterParticipantInfoText: 'Syötä vaaditut tiedot jatkaaksesi kassalle.',
  purchaser: 'Ostaja',
  firstName: 'Etunimi',
  lastName: 'Sukunimi',
  email: 'Sähköposti',
  optionalEmail: 'Sähköposti: (valinnainen)',
  'phone:': 'Puhelin',
  participantFieldPlaceholder:
    'Lisää uusi tai valitse olemassa oleva osallistuja',
  reservationSummary: 'Varauksen yhteenveto',
  editParticipantsDetails: 'Muokkaa osallistujan tietoja',
  participantDetails: 'Tiedot',
  duplicatePurchaserText: 'Sama kuin ostaja',
  phone: 'Puhelin',
  addParticipant: 'Lisä {{tierLabel}}',
  participant: 'Osallistuja',
  removeParticipant: 'Poista',
  experienceCheckoutCompleted: 'Elämyksen maksu suoritettu',
  experienceCartCheckout: 'Elämysten ostoskorin kassa',
  experienceLimitReached:
    'Valitettavasti tämä elämys on saavuttanut enimmäisosallistujamääränsä',
  payment: 'Maksu',
  duration: 'Kesto',
  discountCode: 'Alennuskoodi',
  removeCode: 'Poista koodi',
  invalidCodeValidation: 'Virheellinen kuponkikoodi',
  networkErrorDiscountCode: 'Jokin meni vikaan meidän puolellamme',
  onlyOneCouponCodeAllowed: 'Vain yksi kuponkikoodi on sallittu',
  creditCodeHasAlreadyBeenApplied: 'Luottokoodi on jo käytetty',
  discount: 'Alennus',
  promo: 'Tarjous',
  promoCode: 'Tarjouskoodi',
  apply: 'Käytä',
  total: 'Yhteensä',
  subTotal: 'Välisumma',
  includes: 'Sisältää',
  and: 'ja',
  addHostNotes: 'Lisää muistiinpanoja isännällesi',
  brandAggreementText:
    'Hyväksyn tai vakuutan, että olen valtuutettu osallistujan/osallistujien puolesta hyväksymään seuraavat ehdot',
  termsAggreementValidation: 'Hyväksy ehdot',
  firstNameValidation: 'Etunimi on pakollinen',
  lastNameValidation: 'Sukunimi on pakollinen',
  emailValidation: {
    emailRequiredText: 'Sähköposti on pakollinen',
    invalidEmail: 'Virheellinen sähköpostiosoite',
    not_specified: 'Virheellinen sähköpostiosoite',
  },
  phoneValidation: {
    'Invalid Phone Number': 'Virheellinen puhelinnumero',
    not_specified: 'Virheellinen',
    phoneRequiredText: 'Puhelinnumero on pakollinen',
  },
  participantFirstNameValidation: 'Osallistujan etunimi on pakollinen',
  participantLastNameValidation: 'Osallistujan sukunimi on pakollinen',
  complete: 'Viimeistele',
  '404Message': 'Ei löytynyt',
  waiting: 'Odottaa...',
  complimentary: 'Maksuton',
  confirmationHeader: 'Elämyksesi on varattu!',
  confirmationText:
    'Vahvistussähköposti lähetettiin osoitteeseen {{email}} lisätiedoilla',
  viewAll: 'Näytä kaikki elämykset',
  paymentMethod: 'Maksutapa',
  creditCard: 'Luottokortti',
  roomCharge: 'Huonelasku',
  memberCharge: 'Jäsenveloitus',
  roomOrReservationNumber: 'Huonenumero tai vahvistusnumero',
  roomNumber: 'Huonenumero',
  roomNumberLegacy: 'Huonenumero / Vahvistuskoodi',
  memberNumber: 'Jäsennumero',
  kicc: 'Helppo maksu',
  chargeValidation: 'Huonenumero ja sukunimi ovat pakollisia',
  memberNumberValidation: 'Jäsennumero on pakollinen',
  invalidRoomNumber: 'Huonenumero on virheellinen',
  invalidRoomNumberLegacy: 'Huonenumero tai vahvistuskoodi on virheellinen',
  invalidMemberNumber: 'Jäsennumero on virheellinen',
  invalidPhoneNumber: 'Puhelinnumero on virheellinen',
  requiredPhoneNumber: 'Puhelinnumero on pakollinen',
  guestNameIsRequired: 'Vieraan nimi on pakollinen',
  roomNumberIsRequired: 'Huonenumero on pakollinen',
  roomNumberIsRequiredLegacy: 'Huonenumero tai vahvistuskoodi on pakollinen',
  roomOrReservationNumberIsRequired:
    'Huonenumero tai vahvistusnumero on pakollinen',
  cardNumberIncomplete: 'Korttinumero on puutteellinen',
  lastNameValidationError: 'Sukunimi on pakollinen',
  isReqd: 'on pakollinen',
  reservationCode: 'Varaus-/vahvistusnumero',
  nonHotelGuest: 'Hotellin ulkopuolinen vieras',
  onPropertyGuest: 'Hotellissa oleva vieras',
  preArrivalGuest: 'Ennakkoon saapuva vieras',
  cardNumber: 'Korttinumero',
  pmsValidationErrorMessage:
    'Virheellinen sukunimi tai huonenumero tai vahvistusnumero',
  pmsDateValidationErrorMessage:
    'Valitettavasti elämyksen päivämäärä ei osu saapumis- ja lähtöpäivien väliin.',
  fullName: 'Koko nimi',
  checkout: 'Kassa',
  editParticipants: 'Muokkaa osallistujia',
  private: 'Yksityinen',
  browseAllExperieces: 'Selaa kaikkia elämyksiä',
  payWithCreditCard: 'Maksa luottokortilla',
  payWithRoomCharge: 'Maksa huonelaskulla',
  payWithMemberCharge: 'Maksa jäsenveloituksella',
  payWith: 'Maksa',
  bookBulkErrorByCard:
    'Varauksesi vahvistamisessa ilmeni ongelma. Korttiasi ei veloitettu.',
  bookBulkErrorByRoomCharge: 'Virheellinen sukunimi ja huonenumero.',
  bookBulkErrorByMemberCharge: 'Virheellinen sukunimi ja jäsennumero.',
  reviewCancellation: 'Tarkista peruutus',
  selectAReservationToCancel: 'Valitse peruutettava varaus',
  confirmCancellation: 'Vahvista peruutus',
  cancellable: 'Peruutettavissa',
  cancelled: 'Peruutettu',
  deadlinePassed: 'Määräaika umpeutunut',
  noCancellations: 'Ei peruutuksia',
  reviewReschedule: 'Varauksesi',
  selectAReservationToReschedule: 'Valitse uudelleenajoitettava varaus',
  confirmReservation: 'Vahvista varaus',
  confirm: 'Vahvista',
  selectADateAndTime: 'Valitse päivämäärä ja aika',
  noOtherSessionsAvailableForThisExperience:
    'Tälle elämykselle ei ole muita saatavilla olevia istuntoja.',
  thisReservationCanNoLongerBeRescheduledPleaseEmail:
    'Tätä varausta ei voi enää siirtää. Lähetä sähköpostia osoitteeseen {{brandEmail}}',
  thisReservationCannotBeRescheduled: 'Tätä varausta ei voi siirtää',
  noTimesAvailable: 'Ei saatavilla olevia aikoja',
  noBookingsAvailable: 'Ei saatavilla olevia varauksia',
  youPaid: 'Maksoit',
  refund: 'Hyvitys',
  yourRefund: 'Hyvityksesi',
  yourRefundWillBeProcessedToTheOriginalPayment:
    'Hyvityksesi käsitellään alkuperäiseen maksutapaan.',
  thisReservationCanNoLongerBeCancelledPleaseEmail:
    'Tätä varausta ei voi enää peruuttaa. Lähetä sähköpostia osoitteeseen {{brandEmail}}',
  reservationCancelled: 'Varaus peruutettu',
  thisReservationCannotBeCancelled: 'Tätä varausta ei voi peruuttaa',
  thisReservationHasAlreadyBeenCancelled: 'Tämä varaus on jo peruutettu',
  theHotel: 'hotelli',
  cancelling: 'Peruutetaan',
  somethingWentWrong: 'Jokin meni vikaan',
  previouslyRefunded: 'Aiemmin hyvitetty',
  remainingBalance: 'Jäljellä oleva saldo',
  notEnoughPoints: 'Pisteitä ei ole tarpeeksi',
  notEnoughPointsDescription:
    'Sinulla ei ole tarpeeksi World of Hyatt -pisteitä tämän ostoksen suorittamiseen.',
  currentPointsBalance: 'Nykyinen pistesaldo: {{count, number}}',
  points: 'pistettä',
  pointsWithCount_one: '{{count, number}} piste',
  pointsWithCount_other: '{{count, number}} pistettä',
  payWithHyattPoints: 'Maksa Hyatt-pisteillä',
  pleaseSignIn: 'Kirjaudu sisään',
  worldOfHyattPoints: 'World of Hyatt -pisteet',
  bookBulkErrorByNotEnoughSeats:
    'Istunnossa ei ole tarpeeksi paikkoja. Kokeile toista istuntoa.',
  phoneNumber: 'Puhelinnumero',
  requestToBookConfirmationText:
    'Vahvistussähköposti lähetettiin osoitteeseen {{email}}',
  reservationRescheduled: 'Varaus siirretty',
  yourReservationWasRescheduledTo: 'Varauksesi siirrettiin ajankohtaan',
  viewExperiences: 'Näytä elämykset',
  joinBook: 'Liity ja varaa',
  signInBook: 'Kirjaudu sisään ja varaa',
  signAndJoin: 'Kirjaudu sisään tai liity varataksesi',
  signAndJoinDescription:
    'World of Hyatt FIND -elämykset ovat yksinomaan World of Hyatt -jäsenille. Kirjaudu sisään tai liity varataksesi ja ansaitaksesi pisteitä. Etkö halua liittyä? Voit silti varata ei-eksklusiivisia elämyksiä poistamalla World of Hyatt -elämyksen ostoskoristasi.',
  promoOrFind: 'Tarjous- tai Find-luottokoodi',
  hyattTermsAndConditions: 'Ehdot ja edellytykset',
  hyattTermsAndConditionsAgreement:
    'Vahvistamalla tämän varauksen hyväksyn peruutuskäytännön. Olen myös lukenut ja hyväksyn henkilötietojeni käytön seuraavan mukaisesti',
  hyattTermsAndConditionsLink: 'Hyattin tietosuojakäytännöt',
  hyattWaiverText:
    'Ostamalla tämän elämyksen hyväksyn, ymmärrän ja tunnustan sekä omasta puolestani että jokaisen ostamalleni elämykselle osallistuvan henkilön puolesta (tarvittaessa) seuraavan',
  hyattWaiverLink: 'yleinen vastuuvapautuslauseke',
  priceDisclaimer: 'Sisältää maksut ennen veroja',
  curatedRecommendations: 'Valikoidut suositukset',
  moreExperiencesYouMightLike: 'Lisää elämyksiä, joista saattaisit pitää',
  similarExperiencesAvailableToBookDirectly:
    'Samankaltaisia elämyksiä, joita voit varata suoraan',
  experiencesAvailableAroundYourBookingDate:
    'Elämyksiä saatavilla varauspäiväsi ympärillä',
  confirmationEmailSent:
    'Lähetimme vahvistuksen osoitteeseen {{email}} lisätiedoilla.',
  youreBooked: 'Varauksesi on tehty',
  purchaserInformation: 'Ostajan tiedot',
  requiredFieldIndicator: '* tarkoittaa pakollista kenttää',
  resourceSelectionTitle: 'Valitse vaihtoehdot',
  resourceSelectionDescription:
    'Valitse vaihtoehto jokaiselle varauksesi kohteelle.',
  resourceUnitLabel: '{{tierName}} {{number}}',
  selectResourceAttribute: 'Valitse {{attributeName}}',
  resourceValueSoldOut: '{{label}} (loppuunmyyty)',
  resourceValueUnavailableWith:
    '{{label}} (ei saatavilla valinnalla {{picks}})',
  resourceOptionsUnavailable:
    'Tämän ajankohdan vaihtoehtoja ei voitu ladata. Yritä uudelleen.',
  resourceOptionsRetry: 'Yritä uudelleen',
  changeResourceSelections: 'Muuta valintojasi',
};
